import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@mantine/core";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { AccountContext, SET_ACTIVE_PERSON } from "../accountContext";
import useLocation from "../../Common/useLocation";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  person: {
    width: "100%",
    border: "2px solid",
    borderColor: (p) =>
      p.isActive ? theme.palette.primary.dark : theme.app.borderColor,
    borderRadius: "4px",
    padding: "4px 8px",

    marginBottom: "8px",
    cursor: "pointer",
    pointerEvents: (p) => (p.isActive ? "none" : "initial"),
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
    "&:hover": {
      backgroundColor: theme.app.hoverBackground[1],
    },
    "@media(max-width: 667px)": {
      width: "100%",
    },
  },
  content: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gridGap: "16px",
    alignItems: "center",
    width: "100%",
  },
  name: {
    fontSize: "0.8125rem",
    color: (p) =>
      p.isActive ? theme.palette.primary.dark : theme.app.labelColor,
    marginLeft: "4px",
    justifySelf: "flex-start",
  },
  inner: {
    justifyContent: "start",
  },
}));

const Person = ({ data, closeDialog, setActive }) => {
  const language = useSelector((state) => state.language);
  const { state, dispatch } = useContext(AccountContext);
  const isActive = data.id === state.activePerson.id;
  const classes = useStyles({ isActive });
  const { navigate } = useLocation();
  const handleSelect = () => {
    navigate(`${process.env.PUBLIC_URL}/`);
    dispatch({ type: SET_ACTIVE_PERSON, payload: data });
    setActive(language.Pages && language.Nav["Home"]);
    closeDialog();
  };

  return (
    <Button
      className={classes.person}
      classNames={{ inner: classes.inner }}
      onClick={handleSelect}
      variant="outline"
      color="dark"
      size="xl"
      aria-label={`${
        isActive ? data?.name + " " + language.Chosen : data?.name
      }`}
    >
      <div className={classes.content}>
        <Avatar
          src={data.photo}
          alt={`${data?.name} ${language.Pages["photo"]}`}
        />
        <Typography className={classes.name}>{data.name}</Typography>
      </div>
    </Button>
  );
};

export default Person;
